"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SignUpOrigin=void 0;var o;(function(e){e.Home="home",e.HomeCountry="home_country",e.HomeGlobal="home_global",e.StoreMenu="store_menu",e.StoresList="stores_list"})(o||(exports.SignUpOrigin=o={}));
//# sourceMappingURL=SignUpOrigin.js.map
